import { useSelector } from 'react-redux';

import type { ReduxState } from '../store';

export function useLanguage() {
  return useSelector((store: ReduxState) => store.app.language);
}
